import { Card } from "@/components/ui/Card";
import { MapPin } from "lucide-react";
import { Order } from "./OrderDetailsPage";

function BillingAddressCard({ order }: { order: Order }) {
  return (
    <Card className="p-4">
      <h2 className="font-semibold mb-4 flex items-center gap-2">
        <MapPin className="w-5 h-5 text-muted-foreground" />
        Adresă Facturare
      </h2>
      <div className="space-y-2">
        <div className="flex gap-5">
          <span className="text-muted-foreground flex items-center gap-2">
            <MapPin className="w-4 h-4" />
            Adresă:
          </span>
          <span>{order.metadata?.billingAddress}</span>
        </div>
      </div>
    </Card>
  );
}

export default BillingAddressCard;
